export const locale = {
    lang: 'en',
    data: {
        SCROLL_TO_TOP: {
            TITLES: {
                TO_TOP: 'Scroll to Top'
            }
        }
    }
};